<template>
  <div class="relative flex flex-col items-center" ref="wrapper">
    <!-- NOTIFICATIONS -->
    <vs-dropdown
      vs-custom-content
      vs-trigger-click
      class="cursor-pointer z-10"
      id="unifiedMenu"
      @click="activeAppId = ''"
    >
      <img
        src="@/assets/images/icons/app-marketplace/flat-icons/unified-app-launch.svg"
        alt="unified-app-launch"
        width="37px"
        height="37px"
        class="cursor-pointer"
      />

      <vs-dropdown-menu
        class="rounded-lg border-0 h-auto custom-width"
        style="font-family: Poppins !important"
      >
        <div
          v-if="
            userAppSubscriptions && Object.keys(userAppSubscriptions).length
          "
          class="grid grid-cols-3 grid-flow-row bg-slate-00 p-2 transition-all duration-1000 ease-in-out justify-between gap-2 md:gap-4"
        >
          <div
            id="uniexpand"
            @click="closeApp"
            class="w-full col-span-3 flex-col bg-slate-100 rounded-3xl my-2 overflow-hidden gap-1"
            :class="gridOrder"
            style="height: 0rem; display: none; opacity: 0"
          >
            <div v-if="activeApps.length > 1">
              <div class="flex flex-col w-full p-2 justify-start gap-2">
                <div
                  v-for="(app, index) in activeApps"
                  :key="index"
                  class="items-center w-full flex justify-start border-transparent hover:bg-white transition-all ease-in-out p-2 rounded-2xl border-solid border-2"
                >
                  <span
                    v-if="app.appId === 'market'"
                    target="_blank"
                    :title="app.organizationName"
                    class="flex items-center gap-4 cursor-pointer"
                    @click="
                      navigateToMarket(app.organizationId, authUserData._id)
                    "
                  >
                    <span class="rounded-xl w-12 h-12 relative flex">
                      <img
                        v-if="app.organizationColor"
                        :src="getAppDataById(app.appId).uni_color_icon"
                        alt=""
                        class="w-100 h-100 object-cover"
                        :style="getFilterColor(app.organizationColor)"
                      />
                      <img
                        v-else
                        :src="getAppDataById(app.appId).uni_icon"
                        alt=""
                        class="w-100 h-100 object-cover"
                      />
                    </span>
                    <span
                      class="text-base text-slate-800 font-medium flex h-full text-left"
                      >{{ app.organizationName }}</span
                    >
                  </span>

                  <!-- UPDATED: Replaced app.loginLink with getComputedLoginLink(app) -->
                  <a
                    v-else
                    :href="getComputedLoginLink(app)"
                    target="_blank"
                    :title="app.organizationName"
                    class="flex items-center gap-4"
                    @click="
                      document.getElementById('unifiedMenu').click();
                      activeAppId = '';
                    "
                  >
                    <span class="rounded-xl w-12 h-12 relative flex">
                      <img
                        v-if="app.organizationColor"
                        :src="getAppDataById(app.appId).uni_color_icon"
                        alt=""
                        class="w-100 h-100 object-cover"
                        :style="getFilterColor(app.organizationColor)"
                      />
                      <img
                        v-else
                        :src="getAppDataById(app.appId).uni_icon"
                        alt=""
                        class="w-100 h-100 object-cover"
                      />
                    </span>
                    <span
                      class="text-base text-slate-800 font-medium flex h-full text-left"
                      >{{ app.organizationName }}</span
                    >
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div
            v-for="(appId, index) in Object.keys(userAppSubscriptions)"
            :key="index"
            class="flex w-full my-3 items-center justify-center gap-3"
            :class="[
              getAppDataById(appId).id ? '' : 'hidden',
              ' order-' + index,
            ]"
            v-show="getAppDataById(appId) !== -1"
          >
            <div
              v-if="
                userAppSubscriptions[appId] &&
                userAppSubscriptions[appId].length > 1
              "
              class="w-full flex justify-center"
            >
              <div
                class="flex flex-col justify-center items-center gap-2 cursor-pointer p-2 rounded-2xl hover:bg-slate-100 w-full h-full"
                :class="{ 'bg-slate-100': appId === activeAppId }"
                @click="expandApp(appId, index)"
              >
                <span
                  class="relative flex w-12 h-12 rounded-2xl bg-transparent p-0"
                >
                  <img
                    :src="getAppDataById(appId).uni_icon"
                    class="object-cover w-full h-full"
                  />
                </span>
                <div class="text-base font-medium text-slate-900 text-center">
                  {{ getAppDataById(appId).shortTitle }}
                </div>
              </div>
            </div>
            <div v-else class="w-full flex justify-center">
              <div
                v-if="appId === 'market'"
                class="w-full flex justify-center"
                target="_blank"
                :title="userAppSubscriptions[appId][0].organizationName"
                @click="
                  navigateToMarket(
                    userAppSubscriptions[appId][0].organizationId,
                    authUserData._id
                  )
                "
              >
                <div
                  class="flex flex-col justify-center items-center gap-2 cursor-pointer p-2 rounded-2xl hover:bg-slate-100 w-full h-full"
                  :class="{ 'bg-slate-100': appId === activeAppId }"
                >
                  <span
                    class="relative flex w-12 h-12 rounded-2xl bg-transparent p-0"
                  >
                    <img
                      :src="getAppDataById(appId).uni_icon"
                      class="object-cover w-full h-full"
                    />
                  </span>
                  <div class="text-base font-medium text-slate-900 text-center">
                    {{ getAppDataById(appId).shortTitle }}
                  </div>
                </div>
              </div>

              <!-- UPDATED: Replaced userAppSubscriptions[appId][0].loginLink with getComputedLoginLink -->
              <a
                v-else
                class="w-full flex justify-center"
                :href="getComputedLoginLink(userAppSubscriptions[appId][0])"
                target="_blank"
                :title="userAppSubscriptions[appId][0].organizationName"
                @click="closeMainMenu"
              >
                <div
                  class="flex flex-col justify-center items-center gap-2 cursor-pointer p-2 rounded-2xl hover:bg-slate-100 w-full h-full"
                  :class="{ 'bg-slate-100': appId === activeAppId }"
                >
                  <span
                    class="relative flex w-12 h-12 rounded-2xl bg-transparent p-0"
                  >
                    <img
                      :src="getAppDataById(appId).uni_icon"
                      class="object-cover w-full h-full"
                    />
                  </span>
                  <div class="text-base font-medium text-slate-900 text-center">
                    {{ getAppDataById(appId).shortTitle }}
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>

        <div
          v-else
          class="flex flex-col lg:flex-row p-4 gap-6 lg:gap-0 lg::items-end items-start"
        >
          <div class="flex flex-col gap-2">
            <p class="text-sm text-left">
              No Apps Installed yet?<br /><span class="font-semibold"
                >Add Apps using your Organization</span
              >
            </p>

            <router-link
              to="/organization/my-organizations"
              class="py-2 px-4 bg-primary text-slate-950 w-fit rounded-lg text-sm font-semibold"
              >Go to Organizations</router-link
            >
          </div>
          <img
            class="lg:w-24 w-full"
            src="@/assets/images/temp-img/unified-empty.svg"
          />
        </div>
        <div></div>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import marketplaceList from "@/assets/data/marketplace-list.js";
import CssFilterConverter from "css-filter-converter";
import axios from "axios"; 

import gsap from "gsap";

export default {
  components: {
    VuePerfectScrollbar,
  },
  data() {
    return {
      settings: {},
      marketplaceList,
      showUnifiedIconTip: false,
      activeApps: [],
      activeAppId: "",
      gridOrder: "",
      localAppSubscriptions: {}, 
    };
  },
  computed: {
    scrollbarTag() { return this.$store.getters.scrollbarTag; },
    orgData() { return this.$store.state.organization.orgData; },
    userData() { return this.$store.state.users.data; },
    authUserData() { return this.$store.state.auth.user; },
    userSelectedOrganization() { return this.$store.state.users.selectedOrganization; },
    userOrganizations() { return this.$store.state.users.userOrganizations; },
    blinkers() { return this.$store.state.dashboard.blinkers; },
    currentBoard() { return this.$store.state.boards.currentBoard; },

    userAppSubscriptions() {
      if (this.localAppSubscriptions && Object.keys(this.localAppSubscriptions).length > 0) {
        return this.localAppSubscriptions;
      }
      return this.$store.state.users.appSubscriptions || {};
    },
  },
  watch: {
    userSelectedOrganization() {
      this.fetchUserAppSubscriptions();
    },
    userOrganizations(newVal) {
      if (newVal && newVal.length) {
        this.fetchUserAppSubscriptions();
      }
    },
    $route: {
      immediate: true,
      handler() {
        this.fetchUserAppSubscriptions();
        this.getBoardDetailsFromRoute();
      }
    }
  },
  created() {
    this.fetchUserAppSubscriptions();
  },
  methods: {
    getComputedLoginLink(app) {
      if (!app || !app.loginLink) return "#";
      const link = app.loginLink;

      // ==========================================
      // 1. HANDLE RESUME EDITOR APP
      // ==========================================
      if (link.includes("resume-editor.getboarded.com") || link.includes("editor.getboarded.com")) {
        try {
          const urlObj = new URL(link);
          const token = urlObj.searchParams.get("token") || localStorage.getItem("accessToken") || "";
          const userId = this.authUserData?._id || "";

          let hasData = false;
          if (this.userData) {
            const edu = this.userData.educationalQualifications || [];
            const career = this.userData.careerHistory || [];
            const projects = this.userData.projects || [];
            
            let skills = [];
            if (this.userData.extraCurricular && this.userData.extraCurricular.length > 0) {
              skills = this.userData.extraCurricular[0].skills || [];
            }

            if (
              edu.length > 0 || career.length > 0 || projects.length > 0 || 
              skills.length > 0 || this.userData.about || this.userData.profession ||
              this.userData.address || this.userData.contactNumber
            ) {
              hasData = true;
            }
          }

          const targetRoute = hasData ? '/preview' : '/about';
          return `https://editor.getboarded.com/oauth-callback?organization=default&token=${token}&userId=${userId}&redirect=${encodeURIComponent(targetRoute)}`;
        } catch (error) {
          console.error("Failed to parse Editor app login link:", error);
          return link;
        }
      }

      // ==========================================
      // 2. HANDLE COACH APP (TEMPORARY QUEST CARD LOGIC)
      // ==========================================
      if (link.includes("coach.getboarded.com")) {
        try {
          // Gather email from Vuex state or LocalStorage (matching your Quest Card logic)
          const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
          const email = this.authUserData?.email || userInfo.email || this.userData?.email || "";

          if (email) {
            // Extract string before the @ symbol
            const user = email.slice(0, email.indexOf("@"));
            
            // Return the working OAuth route
            return `https://api.coach.getboarded.com/oauth/?selectedAccount=${user}`;
          }

          // Fallback if no email is found (direct to auth login screen)
          return "https://auth.getboarded.com/auth/views/login/?next=https%3A%2F%2Fapi.coach.getboarded.com%2Foauth-callback&appSource=Coach";
        } catch (error) {
          console.error("Failed to apply temporary Coach logic:", error);
          return link;
        }
      }

      // ==========================================
      // 3. FALLBACK FOR ALL OTHER APPS
      // ==========================================
      return link;
    },

    getBoardDetailsFromRoute() {
      const boardId = this.$route.params.boardId;
      if (boardId) {
        this.$store.dispatch("boards/fetchBoardDetails", boardId)
          .then((res) => {
            if (res && res.data) {
              this.localBoardData = res.data;
              this.cacheBoardApp(res.data);
            }
          })
          .catch((err) => {
            console.error("Error fetching board details:", err);
          });
      } else {
        this.localBoardData = null;
      }
    },

    cacheBoardApp(board) {
      if (!board || !board.organizationId || !board.installedApps) return;
      try {
        let cache = localStorage.getItem("gb_cached_board_apps");
        cache = cache ? JSON.parse(cache) : {};
        
        cache[board.organizationId] = {
          organizationId: board.organizationId,
          organizationName: board.orgData ? board.orgData.title || board.orgData.name : "Current Org",
          organizationColor: board.orgData ? board.orgData.primaryThemeColor : "#28C76F",
          installedApps: board.installedApps,
          boardId: board._id
        };
        
        localStorage.setItem("gb_cached_board_apps", JSON.stringify(cache));
      } catch (e) {
        console.error("Failed to write board apps to cache", e);
      }
    },

    expandApp(appId, appIndex) {
      if (appId !== this.activeAppId) {
        const tl = gsap.timeline({ defaults: { duration: 0.2, ease: "rough", repeat: 0 } });
        tl.fromTo("#uniexpand", 0.2, { opacity: 0, display: "none", height: "0rem" }, { opacity: 0, display: "flex", height: "0rem" });
        tl.fromTo("#uniexpand", 0.2, { opacity: 0, display: "flex", height: "0rem" }, { opacity: 1, display: "flex", height: "auto" });
        this.activeApps = this.userAppSubscriptions[appId];
        this.activeAppId = appId;

        if (appIndex / 3 <= 1) { this.gridOrder = "order-4"; } 
        else if (appIndex / 3 > 1 && appIndex / 3 <= 2) { this.gridOrder = "order-7"; } 
        else { this.gridOrder = "order-last"; }
      } else {
        const tl = gsap.timeline({ defaults: { duration: 0.2, ease: "rough", repeat: 0 } });
        tl.fromTo("#uniexpand", 0.1, { opacity: 0, display: "flex", height: "10rem" }, { opacity: 0, display: "none", height: "0rem" });
        this.activeAppId = "";
      }
    },

    closeApp() {
      const tl = gsap.timeline({ defaults: { duration: 0.2, ease: "rough", repeat: 0 } });
      tl.fromTo("#uniexpand", 0.1, { opacity: 0, display: "flex", height: "0rem" }, { opacity: 0, display: "none", height: "0rem" });
    },
    async navigateToMarket(_orgId, _userId) {
      this.$vs.loading();
      const accessToken = localStorage.getItem("accessToken");
      await this.fetchOrgDetailsFromOrgId(_orgId, _userId, accessToken);
      this.activeAppId = "";
      this.closeMainMenu();
      this.$vs.loading.close();
    },
    async fetchOrgDetailsFromOrgId(_orgId, _userId, accessToken) {
      this.$store.dispatch("users/fetchOrganizationById", _orgId).then((res) => {
        this.$vs.loading.close();
        const dynamicMarketPlaceRoute = `https://market.getboarded.com/${res.slug}?userId=${_userId}&authToken=${accessToken}`;
        window.open(dynamicMarketPlaceRoute, "_blank");
      });
    },
    fetchUserAppSubscriptions() {
      if (!this.authUserData || !this.authUserData._id) return;

      const pythonApiUrl = process.env.VUE_APP_API_URL ; 
      const token = localStorage.getItem("accessToken");
      const userId = this.authUserData._id;

      axios.get(`${pythonApiUrl}/api/v2/users/${userId}/app-subscriptions`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        if (res.data) {
          this.localAppSubscriptions = res.data;
        }
      })
      .catch(err => {
        console.error("Unified Menu: Failed to fetch unified subscriptions from Python API:", err);
      });
    },
    getAppDataById(id) {
      const appIndex = this.marketplaceList.findIndex((app) => app.id === id);
      if (appIndex !== -1) return this.marketplaceList[appIndex];
      else return appIndex;
    },
    getOrgData(orgId) {
      if (!orgId || !this.userOrganizations || !this.userOrganizations.length) return {};
      const orgData = this.userOrganizations.find((org) => org.organizationId === orgId);
      if (!orgData || !orgData.organizationData) return {};
      return orgData.organizationData;
    },
    readUnifiedMenu() {
      this.showUnifiedIconTip = false;
      this.$store.commit("dashboard/UPDATE_DASHBOARD_BLINKERS", { status: true, key: "readUnifiedMenuTip" });
    },
    handleClickOutside(event) {
      const popup = this.$refs.blinkerTip;
      const wrapper = this.$refs.wrapper;
      if (!popup.contains(event.target) && !wrapper.contains(event.target)) {
        this.showUnifiedIconTip = false;
        window.removeEventListener("click", this.handleClickOutside);
      }
    },
    showBlinkerTip() {
      this.showUnifiedIconTip = true;
      window.addEventListener("click", this.handleClickOutside);
    },
    closeMenu() { this.activeAppId = ""; },
    closeMainMenu() { document.getElementById("unifiedMenu").click(); },
    getFilterColor(hexColor) {
      const result = CssFilterConverter.hexToFilter(hexColor);
      return `filter: ${result.color}`;
    },
  },
};
</script>

<style lang="scss">
.notification-dropdown {
  width: 400px !important;
  height: auto !important;
}

.unified-app-title {
  color: #798ba0;
}

.custom-width {
  width: 350px !important;

  .vs-dropdown--menu {
    border-radius: 1rem !important;
  }
}

@media (max-width: 430px) {
  .custom-width {
    width: 280px !important;
  }
}
</style>